export default "__VITE_ASSET__CZ$L0b$m__"